// function to sort an object by its value property
function sortData(dataObj){
    var sortable = [];
    for (var value in dataObj) {
      if (dataObj.hasOwnProperty(value)) {
        sortable.push([value, dataObj[value]]);
      }
    }
    sortable.sort(function(a, b) {
      if (b[1] && !a[1]) {
        return 1;
      }else if(!b[1] && a[1]) {
        return -1
      }else{
        return b[1] - a[1];
      }
    });
    return sortable;
}

// returns a sorted object
function sortObjects(objToSort) {
    var newObject = {};
    var sortedArray = sortData(objToSort);
    for (var i = 0; i < sortedArray.length; i++) {
        var key = sortedArray[i][0];
        var value = sortedArray[i][1];
        newObject[key] = value;
    }
    return newObject;
}

module.exports = sortObjects



// WEBPACK FOOTER //
// ./src/assets/js-on/sortObjects.js